<template>
  <ElForm
    class="step-one-form form"
    ref="propertyFormRef"
    :rules="rules"
    :model="propertyForm"
  >
    <TabList
      class="step-one-form__tabs"
      :objects="objects"
      @tab-click="tabClickHandler"
    />

    <div class="step-one-form__item form__item">
      <ElFormItem
        class="step-one-form__item-col form__col"
        prop="bank"
      >
        <ElAutocomplete
          class="step-one-form__autocompleate"
          v-model="bank"
          placeholder="Банк кредитор"
          :fetch-suggestions="querySearchBank"
          :popper-append-to-body="false"
          @select="(item) => formSelectHandler(item, 'bank')"
          @input="() => propertyForm.bank = ''"
        >
          <template #prefix>
            Банк кредитор
          </template>

          <template slot-scope="{ item }">
            <div class="step-one-form__autocompleate-option">
              <img v-if="item.iconPath" class="step-one-form__autocompleate-option-icon" :src="item.iconPath" alt="">

              <div class="step-one-form__autocompleate-option-value">{{ item.value }}</div>
            </div>
          </template>

          <i class="form__item-icon-lock" slot="suffix"></i>
        </ElAutocomplete>
      </ElFormItem>

      <ElFormItem
        v-if="isCreditDateVisible"
        class="step-one-form__item-col form__col"
        prop="credit_date"
      >
        <ElDatePicker
          v-model="propertyForm.credit_date"
          v-mask="{mask: '9{2}.9{2}.9{4}'}"
          ref="birthPicker"
          type="date"
          placeholder="Дата выдачи кредита"
          format="dd.MM.yyyy"
          value-format="dd.MM.yyyy"
          :picker-options="{ firstDayOfWeek: 1 }"
        />

        <span class="form__label">Дата выдачи кредита</span>
      </ElFormItem>

      <ElFormItem
        class="step-one-form__item-col form__col"
        prop="credit_balance"
      >
        <ElInput
          v-model="propertyForm.credit_balance"
          placeholder="Остаток кредита"
          v-mask="{regex: '^[0-9]*'}"
        >
          <template #prefix>
            Остаток кредита
          </template>

          <i class="form__item-icon-lock" slot="suffix"></i>
        </ElInput>
      </ElFormItem>

      <ElFormItem
        class="step-one-form__item-col form__col"
        prop="region"
      >
        <ElAutocomplete
          class="form__autocompleate"
          v-model="region"
          placeholder="Город объекта страхования"
          :fetch-suggestions="querySearchRegion"
          :popper-append-to-body="false"
          value-key="value"
          @select="(item) => formSelectHandler(item, 'region')"
          @input="() => propertyForm.region = ''"
        >
          <template #prefix>
            Город объекта страхования
          </template>

          <i class="form__item-icon-lock" slot="suffix"></i>
        </ElAutocomplete>
      </ElFormItem>

      <ElFormItem
        class="step-one-form__item-col form__col"
        prop="birth_date"
      >
        <ElDatePicker
          v-model="propertyForm.birth_date"
          v-mask="{mask: '9{2}.9{2}.9{4}'}"
          ref="birthPicker"
          type="date"
          placeholder="дд.мм.гггг"
          :default-value="subYears(new Date(), 18)"
          format="dd.MM.yyyy"
          value-format="dd.MM.yyyy"
          :picker-options="{ disabledDate: (time) => disableInvalidBirthDates(time), firstDayOfWeek: 1 }"
        />

        <span class="form__label">Дата рождения</span>
      </ElFormItem>

      <ElFormItem
        class="step-one-form__item-col form__col"
        prop="gender"
      >
        <ElSelect
          v-model="propertyForm.gender"
          placeholder="Пол"
          :popper-append-to-body="false"
          @change="(item) => formSelectHandler(item, 'gender')"
          @blur="genderBlurHandler"
        >
          <template #prefix>
            Пол
          </template>

          <ElOption
            v-for="(option, index) in genders"
            :key="index"
            :label="option.label"
            :value="option.value"
          >
          </ElOption>
        </ElSelect>
      </ElFormItem>
    </div>

    <div class="step-one-form__buttons form__buttons">
      <BaseButton
        class="step-one-form__buttons-item"
        text="Рассчитать"
        size="large"
        @click.native="submitHandler($refs.propertyFormRef)"
      />
    </div>
  </ElForm>
</template>

<script>
import { subYears } from 'date-fns';
import { calculatorEipoteka } from '@/api/routes/calculator-eipoteka';
import TabList from '@/components/shared/tabs/TabList';
import BaseButton from '@/components/ui/BaseButton';

export default {
  name: 'Step1',
  components: {
    BaseButton,
    TabList,
  },
  props: [
  ],
  data() {
    return {
      bank: '',
      region: '',
      propertyForm: {
        bank: null,
        credit_date: '',
        credit_balance: '',
        region: null,
        birth_date: '',
        gender: '',
        objectId: '',
      },
      objects: [],
      rules: {
        bank: [
          { required: true, message: 'Поле банка кредитора обязательно для заполнения', trigger: 'blur' },
        ],
        credit_date: [
          { required: true, message: 'Поле даты выдачи кредита обязательно для заполнения', trigger: 'blur' },
        ],
        credit_balance: [
          { required: true, message: 'Поле остатка кредита обязательно для заполнения', trigger: 'blur' },
        ],
        region: [
          { required: true, message: 'Поле региона объекта страхования обязательно для заполнения', trigger: 'blur' },
        ],
        birth_date: [
          { required: true, message: 'Поле даты рождения обязательно для заполнения', trigger: 'blur' },
        ],
        gender: [
          { required: true, message: 'Поле пол обязательно для заполнения', trigger: 'blur' },
        ],
      },
      genders: [{
        value: 'M',
        label: 'мужской'
      }, {
        value: 'F',
        label: 'женский'
      }],
      banks: [],
      regions: [],
      stepOneSessionData: null,
    }
  },
  computed: {
    isCreditDateVisible() {
      return this.propertyForm?.bank?.useCreditDate;
    },
  },
  methods: {
    tabClickHandler(dataTabs) {
      this.objects = dataTabs;

      this.setActiveTab();
    },
    setActiveTab() {
      this.propertyForm.objectId = this.objects.find((tab) => tab.isActive)?.objectId;
    },
    formSelectHandler(data, formField) {
      this.propertyForm[formField] = data;

      this.$refs.propertyFormRef.validateField(formField);
    },
    querySearchBank(queryString, cb) {
      const banks = this.banks;
      const results = queryString ? banks.filter(this.createFilter(queryString)) : banks;

      cb(results);
    },
    querySearchRegion(queryString, cb) {
      const regions = this.regions;
      let results = queryString ? regions.filter(this.createFilter(queryString)) : regions;

      if (results.length == 0) {
          results = regions.filter(this.createFilter('Другой город'));
      }

      cb(results);
    },
    createFilter(queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    disableInvalidBirthDates(birthDate) {
      const currentDate = new Date();
      const eighteenYearsAgo = subYears(currentDate, 18);

      return birthDate.getTime() > eighteenYearsAgo.getTime();
    },
    genderBlurHandler() {
      this.$refs.propertyFormRef.validateField('gender');
    },
    async loadSelectOptions(action) {
      const responseData = await calculatorEipoteka(action);

      if (!responseData.result) {
        return [];
      }

      const array = responseData.response;

      return array.map((item) => ({
        ...item,
        value: item.name,
      }));
    },
    restoringForm(prevFormData) {
      this.propertyForm = prevFormData;
      this.bank = prevFormData.bank.name;
      this.region = prevFormData.region.name;

      this.objects = this.objects.map((object) => ({
        ...object,
        isActive: object.objectId === prevFormData.objectId,
      }))
    },
    submitHandler(formEl) {
      formEl.validate(valid => {
        if (valid) {
          this.$emit('step-one-submit', this.propertyForm, this.stepOneSessionData);
        }
      });
    },
    subYears,
  },
  async mounted() {
    const objectsResponseData = await calculatorEipoteka('getObjectsAction');

    if (!objectsResponseData.result) {
      this.objects = []
    } else {
      this.objects = objectsResponseData.response;
    }

    this.banks = await this.loadSelectOptions('getBanksAction');
    this.regions = await this.loadSelectOptions('getRegionsAction');

    this.stepOneSessionData = await calculatorEipoteka('getSessionData');

    if (this.stepOneSessionData && this.stepOneSessionData.stepOne) {
      this.restoringForm(this.stepOneSessionData.stepOne);
    } else if (objectsResponseData.result) {
      this.objects[0].isActive = true;
      this.objects = [...this.objects]
    }
    this.setActiveTab();
  },
}
</script>

<style lang="scss" scoped>
.step-one-form {
  &__tabs {
    &:not(:last-child) {
      margin-bottom: rem(32);
    }
  }

  &__item {
    display: flex;
    flex-wrap: wrap;
    gap: rem(16);

    &-col {
      @include flex-width-three-in-row(16);

      @media #{$screen-big} {
        @include flex-width-two-in-row(16);
      }

      @media #{$screen-small} {
        width: 100%;
      }
    }
  }

  &__buttons {
    justify-content: flex-end;

    margin-top: rem(24);

    &-item {
      @media #{$screen-big} {
        width: auto;
      }

      @media #{$screen-small} {
        width: 100%;
      }
    }
  }

  &__autocompleate {
    &-option {
      display: flex;
      align-items: center;
      gap: rem(16);

      &-icon {
        width: rem(32);
        height: rem(32);

        object-fit: contain;
        border-radius: rem(5);
      }

      &-value {
        @include text-props(16, 20.8);
      }
    }
  }
}
</style>

